import { Component, inject, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ImagePickerComponent } from 'app/_componentes/image-picker/image-picker.component';
import { getFilenameFromUrl } from 'app/_utils/general-utils';
import { BuyerCreateQuotationService } from '../../create-quotation.service';
import { ApiResponseModel } from 'app/_models/apiResponseModel';

@Component({
    selector: 'quotation-other-infos-component', templateUrl: './quotation-other-infos.component.html', styleUrls: ['./quotation-other-infos.component.scss'],
    standalone: false
})
export class BuyerCreateQuotationOtherInfosComponent {
    @ViewChild(ImagePickerComponent) imagePickerComponent: ImagePickerComponent;

    fb = inject(FormBuilder);

    otherInfosFormGroup = this.fb.group({
        comment: [""]
    });

    get quotationComment() {
        var formValue = this.otherInfosFormGroup.value;
        return formValue.comment;
    }

    get quotationImages() {
        return this.imagePickerComponent.selectedImages;
    }

    constructor(private buyerCreateQuotationService: BuyerCreateQuotationService) {}

    addImage(imageB64: string, imageName: string) {
        this.imagePickerComponent.addB64Image(imageB64, imageName);
    }

    loadQuotationFileImages(photosUrl: string[]) {
        this.imagePickerComponent.startLoader();

        this.buyerCreateQuotationService.convertImageUrlToB64(photosUrl).subscribe({
            next: (response: ApiResponseModel<{imageB64: string, originalUrl: string}[]>) => {
                if (response && response.success) {
                    response.result.forEach(result => {
                        const filename = getFilenameFromUrl(result.originalUrl);
                        this.addImage(result.imageB64, filename);
                    });
                }

                this.imagePickerComponent.stopLoader();
            },
            error: err => {
                console.error(err);
                this.imagePickerComponent.stopLoader();
            }
        });
    }
    reset() {
        this.otherInfosFormGroup.reset();
        this.imagePickerComponent.resetImages();
    }
}
